import { BaseModel } from '../../base/base-model'

/**
 * @memberOf loavies.models.transaction
 * @constructor
 */
export class MarketplaceTransactionQueryModel extends BaseModel {
  /**
   * https://www.sharetribe.com/api-reference/marketplace.html#query-transactions
   * @param {'sale'|'order'} [only]
   * @param {string|string[]} [lastTransitions] Comma separated list of strings
   */
  constructor({
    only,
    lastTransitions,
  }) {
    super()

    /** @type {'sale'|'order'} */
    if (!this.isUndefined(only)) this.only = only

    /** @type {string|string[]} */
    this.lastTransitions = lastTransitions
  }
}
